module.exports = __webpack_public_path__ + "static/media/square-white.2364369e.png";